/**
 * Service: partnersApi
 */
angular.module('acme.common.service.partnersApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('PartnersApiService', [ '$http', '$q', '$timeout', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, $q, $timeout, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      init: function(endpoint) {
        this.service = endpoint + '/partners';
        this.user.service = endpoint + '/partners/account/user';
        this.categories.service = endpoint + '/account/categories';
        this.events.service = endpoint + '/accountcategoryeventschedule';
        this.reseller.service = endpoint + '/reseller';
        this.notes.service = endpoint + '/partners/notes';
        this.templates.service = endpoint + '/accountcategoryeventschedule/relations/eventTemplates';
        this.payments.service = endpoint + '/policy/payments';
        this.contacts.service = endpoint + '/partners/account';
        return this;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['status', 'page', 'pageSize', 'sortDirection', 'sortField', 'search', 'type', 'category']
            }
          });
          q = qs.query;
        }
        //TODO: find a smart way to do this. v2 string replacent is just TEMP
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        });
      },

      detail: function(partnerId) {
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/' + partnerId
        });
      },

      approve: function(requestId) {
        return $http({
          method: 'post',
          url: this.service + '/approve/' + requestId
        });
      },

      decline: function(requestId) {
        return $http({
          method: 'post',
          url: this.service + '/decline/' + requestId
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {
              id: props.company.id,
              name: props.company.name,
              companyUrl: props.company.companyUrl,
              phoneNumber: props.company.phoneNumber,
              streetAddress1: props.company.streetAddress1,
              streetAddress2: props.company.streetAddress2,
              city: props.company.city,
              state: props.company.state,
              zipCode: props.company.zipCode,
              country: props.company.country,
              timezone: props.company.timezone
            }
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service + '/approve/',
          data: {
            categoryId: props.category.id,
            partner: {
              contactFirstName: props.primaryContact.firstName,
              contactLastName: props.primaryContact.lastName,
              contactEmail: props.primaryContact.email,
              contactPhone: props.primaryContact.phoneNumber,
              companyName: props.company.name,
              companyUrl: props.company.companyUrl,
              companyPhone: props.company.phoneNumber,
              billingAddress1: props.company.streetAddress1,
              billingAddress2: props.company.streetAddress2,
              billingCity: props.company.city,
              billingState: props.company.state,
              billingZip: props.company.zipCode,
              country: props.company.country,
              timezone: props.company.timezone
            }
          }
        });
      },

      categories: {
        service: '',

        list: function(props) {
          var q = '';
          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['status', 'page', 'pageSize', 'sortDirection', 'sortField', 'search']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        detail: function(id) {
          var qs = new QueryStringBuilderFactory({
            props: {categoryId: id},
            fields: {
              requires: ['categoryId']
            }
          });
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/relations' + qs.query
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service.replace(/v1/,'v2') + '/' + id
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service.replace(/v1/, 'v2'),
            data: {
              name: props.name,
              description: props.description
            }
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service.replace(/v1/,'v2') + '/' + props.id,
            data: {
              id: props.id,
              name: props.name,
              description: props.description
            }
          });
        },

        assignment: function(id) {
          return $http({
            method: 'get',
            url: this.service.replace(/v1/,'v2') + '/relations'
          });
        },

        assign: function(props) {
          return $http({
            method: 'post',
            url: this.service.replace(/v1/,'v2') + '/relations',
            data: {
              accountId: props.accountId,
              categoryId: props.categoryId
            }
          });
        },

        unassign: function(id) {
          return $http({
            method: 'delete',
            url: this.service.replace(/v1/,'v2') + '/relations/' + id
          });
        },

        reassign: function(props) {
          return $http({
            method: 'put',
            url: this.service.replace(/v1/,'v2') + '/relations/' + props.id,
            data: {
              id: props.id,
              accountId: props.accountId,
              categoryId: props.categoryId
            }
          });
        }

      },

      notes: {

        service: '',

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/' + props.id,
            data: {
              notes: props.notes
            }
          });
        }

      },

      templates: {

        service: '',

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        update: function(props) {
          // Since all operations are post, put, or delete we are opting to use POST instead of PUT
          return $http({
            method: 'post',
            url: this.service + '/' + props.eventTemplateId,
            data: props.data
          });
        }

      },

      events: {

        service: '',

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/relations/' + id
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service + '/relations',
            data: {
              discountId: props.discountId,
              categoryId: props.categoryId,
              eventTemplateId: props.eventTemplateId
            }
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/relations/' + props.id,
            data: {
              id: props.id,
              discountId: props.discountId,
              categoryId: props.categoryId,
              eventTemplateId: props.eventTemplateId
            }
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/relations/' + id
          });
        }
      },

      reseller: {
        event: function(props) {
          return $http({
            method: 'get',
            url: this.service + '/event/instances/'+props.accountId+'/'+props.eventId
          });
        },

        events: function(props) {
          var query = [],
              q = '';

          if (props.startTime) {
            query.push('startTime='+props.startTime);
          }

          if (props.endTime) {
            query.push('endTime='+props.endTime);
          }

          if (props.templateId) {
            query.push('templateId='+props.templateId);
          }

          if (props.type) {
            query.push('type='+props.type);
          }

          if (query.length > 0) {
            q = '?' + query.join('&');
          }
          return $http({
            method: 'get',
            url: this.service + '/event/instances/'+props.accountId + q
          });
        }
      },

      payments: {

        service: '',

        account: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/account/' + id
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              type: props.type,
              accountId: props.accountId,
              uniqueVoucherNumbers: props.uniqueVoucherNumbers,
              ticketDelivery: props.ticketDelivery,
              balanceDue: {
                days: props.balanceDueDays
              },
              deposit: {
                daysBeforeEvent: props.depositDueDays,
                minAmount: props.depositMinimumAmount,
                percent: props.depositMinimumPercent
              }
            }
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              type: props.type,
              accountId: props.accountId,
              uniqueVoucherNumbers: props.uniqueVoucherNumbers,
              ticketDelivery: props.ticketDelivery,
              balanceDue: {
                days: props.balanceDueDays
              },
              deposit: {
                daysBeforeEvent: props.depositDueDays,
                minAmount: props.depositMinimumAmount,
                percent: props.depositMinimumPercent
              }
            }
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/' + id
          });
        }

      },

      user: {

        service: '',

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              id: props.id,
              accountId: props.accountId,
              firstName: props.firstName,
              lastName: props.lastName,
              email: props.email,
              primary: props.primary,
              phoneNumber: props.phoneNumber
            }
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              accountId: props.accountId,
              firstName: props.firstName,
              lastName: props.lastName,
              email: props.email,
              phoneNumber: props.phoneNumber
            }
          });
        }

      },

      contacts: {
        service: '',

        list: function(id, props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['page', 'pageSize', 'sortDirection', 'sortField', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + "/" + id + '/user' + q
          });
        },

        create: function(props) {
          var data = {
            accountId: props.accountId,
            firstName: props.firstName,
            lastName: props.lastName,
            email: props.email,
            phoneNumber: props.phoneNumber,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            city: props.city,
            state: props.state,
            zipCode: props.zipCode,
            country: props.country,
            primary: false
          };
          return $http({
            method: 'post',
            url: this.service + "/user",
            data: data
          });
        },

        update: function(props) {
          var data = {
            id: props.id,
            accountId: props.accountId,
            firstName: props.firstName,
            lastName: props.lastName,
            email: props.email,
            phoneNumber: props.phoneNumber,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            city: props.city,
            state: props.state,
            zipCode: props.zipCode,
            country: props.country,
            primary: props.primary || false
          };
          return $http({
            method: 'put',
            url: this.service + "/user",
            data: data
          });
        },

        remove: function(id, props) {
          var data = {
            id: id,
            accountId: props.accountId,
            firstName: props.firstName,
            lastName: props.lastName,
            email: props.email,
            phoneNumber: props.phoneNumber,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            city: props.city,
            state: props.state,
            zipCode: props.zipCode,
            country: props.country,
            primary: false
          };
          return $http({
            method: 'delete',
            url: this.service + "/user/" + id,
            data: data
          });
        }
      }

    };

}]);